import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import { Layout } from "./components/Layout";
import { Spinner } from "./components/ui";
import { Login } from "./routes/Login";
import { AcceptInvitation } from "./routes/AcceptInvitation";
import { PortalDashboard } from "./routes/portal/Dashboard";
import { PortalCases } from "./routes/portal/Cases";
import { PortalCaseDetail } from "./routes/portal/CaseDetail";
import { PortalInspectionView } from "./routes/portal/InspectionView";
import { CrmDashboard } from "./routes/crm/Dashboard";
import { CrmCases } from "./routes/crm/Cases";
import { CrmCaseCreate } from "./routes/crm/CaseCreate";
import { CrmCaseDetail } from "./routes/crm/CaseDetail";
import { CrmPipeline } from "./routes/crm/Pipeline";
import { CrmInspect } from "./routes/crm/Inspect";
import { CrmClients } from "./routes/crm/Clients";
import { CrmInvitations } from "./routes/crm/Invitations";

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Root />
      </BrowserRouter>
    </AuthProvider>
  );
}

function Root() {
  const { principal, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <Spinner />
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/accept-invitation" element={<AcceptInvitation />} />
      <Route path="/login" element={principal ? <Navigate to="/" replace /> : <Login />} />
      {principal ? (
        <Route element={<Layout />}>
          {principal.role === "CUSTOMER" ? (
            <>
              <Route path="/" element={<PortalDashboard />} />
              <Route path="/cases" element={<PortalCases />} />
              <Route path="/cases/:id" element={<PortalCaseDetail />} />
              <Route path="/cases/:id/inspection" element={<PortalInspectionView />} />
            </>
          ) : (
            <>
              <Route path="/" element={<CrmDashboard />} />
              <Route path="/cases" element={<CrmCases />} />
              <Route path="/pipeline" element={<CrmPipeline />} />
              <Route path="/cases/new" element={<CrmCaseCreate />} />
              <Route path="/cases/:id" element={<CrmCaseDetail />} />
              <Route path="/cases/:id/inspect" element={<CrmInspect />} />
              <Route path="/clients" element={<CrmClients />} />
              <Route path="/invitations" element={<CrmInvitations />} />
            </>
          )}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      ) : (
        <Route path="*" element={<Navigate to="/login" replace />} />
      )}
    </Routes>
  );
}
